/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { closelightbox } from '../../util/Functions';
import { Close } from "@mui/icons-material";
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";
import "moment/locale/es";

const TutukaOperationManual = (props) => {
	const [zPos, setZPos] = useState(45)
  const [typeOpration, setTypeOpration] = useState("");
  const [typeTypeTrx, setTypeTrx] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [error, setErrors] = useState({
    description: "",
    tx_uuid_original: "",
  });
	const typeServiceList = [
		{ value: "deduct", label: "Deduct" },
		{ value: "deductReversal", label: "DeductReversal" },
		{ value: "deductAdjustment", label: "DeductAdjustment" },
		{ value: "loadAdjustment", label: "LoadAdjustment" },
	]
	const typeOprationList = [
		{ value: "POS", label: "POS" },
		{ value: "ATM", label: "ATM" },
		{ value: "Adjustment", label: "Adjustment" },
		{ value: "Cashback at POS", label: "Cashback at POS" },
		{ value: "Deposit", label: "Deposit" },
	]
  const [form, setForm] = useState({
    type_service: "",
    type_trx: "",
    wallet_uuid: "",
    description: "",
    referenceid: "",
    trx_id: "",
    amount: 0,
  });

  useEffect(() => {}, []);

  const send = async () => {
    props.changeLoader(true);
		setZPos(-1)
    var data = form;
    var dataRequest = {};
    var uuid = props.contentModal.uuid;
    var email = props.contentModal.email;

    switch (typeOpration) {
      case "deduct": {
        dataRequest = {
          data: {
            method_name: "Deduct",
            wallet_uuid: data.wallet_uuid,
            amount: data.amount,
            description: data.description,
            transaction_type: "POS",
            transaction_id: data.trx_id,
            applicant: {
              uuid: uuid,
              email: email,
            },
          },
        };
        break;
      }
      case "deductReversal": {
        dataRequest = {
          data: {
            method_name: "DeductReversal",
            wallet_uuid: data.wallet_uuid,
            amount: data.amount,
            description: data.description,
            transaction_id: data.trx_id,
            reference_id: data.referenceid,
            applicant: {
              uuid: uuid,
              email: email,
            },
          },
        };
        break;
      }
      case "deductAdjustment": {
        dataRequest = {
          data: {
            method_name: "DeductAdjustment",
            wallet_uuid: data.wallet_uuid,
            amount: data.amount,
            description: data.description,
            transaction_id: data.trx_id,
            reference_id: data.referenceid,
            applicant: {
              uuid: uuid,
              email: email,
            },
          },
        };
        break;
      }
      case "loadAdjustment": {
        dataRequest = {
          data: {
            method_name: "LoadAdjustment",
            wallet_uuid: data.wallet_uuid,
            amount: data.amount,
            description: data.description,
            transaction_id: data.trx_id,
            reference_id: data.referenceid,
            applicant: {
              uuid: uuid,
              email: email,
            },
          },
        };
        break;
      }
      default: {
        dataRequest = null;
        return;
      }
    }
    if (dataRequest != null) {
      var request = await API.service( "tutukaOpManual", dataRequest, props.pos, props.changeAlert, props.changeLoader, props.history);
      if (request.status == 200) {
        if (request.data.data.response == "OK" && request.data.data.content.code == 1) {
          props.changeAlert(true, "success", "Cobro realizado con éxito");
          closelightbox();
        } else {
          props.changeAlert(true, "error", "Error al ejecutar la operación");
        }
      } else {
        props.changeAlert(true, "error", "Error al ejecutar la operación");
      }
    } else {
      props.changeAlert(true, "error", "Error al ejecutar la operación");
    }

    props.changeLoader(false);
		setZPos(45)
  };

  const changeValue = (field, e) => {
    let f = form;
    let err = error;

    f[field] = e.target.value;
    if (!e.target.value) {
      err[field] = "Campo obligatorio";
    } else {
      err[field] = "";
    }

    setForm(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(err)));
    validateForm(f, err);
  };

  const validateForm = (f, err) => {
    if (typeOpration != "") {
      if (typeOpration === "deduct") {
        if (typeTypeTrx != "") {
          if (f["trx_id"] && f["wallet_uuid"] && f["amount"]) {
            setDisabled(false);
          } else {
            setDisabled(true);
          }
        }
      } else {
        if ( f["trx_id"] && f["wallet_uuid"] && f["amount"] && f["referenceid"]) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      }
    }
  };

  const changeSelectTrx = (event) => {
    var value = event.target.value;
    setTypeTrx(value);
  };

  const changeSelect = (key, e) => {
    var value = key.target.value;

    switch (value) {
      case "deduct": {
        setTypeOpration("deduct");
        break;
      }
      case "deductReversal": {
        setTypeOpration("deductReversal");
        break;
      }
      case "deductAdjustment": {
        setTypeOpration("deductAdjustment");
        break;
      }
      case "loadAdjustment": {
        setTypeOpration("loadAdjustment");
        break;
      }

      default: {
        setTypeOpration("");
      }
    }
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle>
					Operación Manual de Tutuka
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>
				
				<DialogContent>
					<Grid container spacing={2} sx={{ marginTop: "10px" }}>
						<Grid item xs={6}>
							<TextField
								label="Servicios" value={typeOpration} onChange={changeSelect.bind(this)} select	size="small" fullWidth >
								<MenuItem value={""}>Seleccione</MenuItem>
								{typeServiceList?.map((item, index) => (
									<MenuItem key={`service-${index}`} value={item.value}>{item.label}</MenuItem>
								))}
							</TextField>
						</Grid>

						{typeOpration === "deduct" && 
							<Grid item xs={6}>
								<TextField
									label="Tipo de Transacción" value={typeTypeTrx} onChange={changeSelectTrx.bind(this)} select	size="small" fullWidth >
									<MenuItem value={""}>Seleccione</MenuItem>
									{typeOprationList?.map((item, index) => (
										<MenuItem key={`operation-${index}`} value={item.value}>{item.label}</MenuItem>
									))}
								</TextField>
							</Grid>
						}

						{typeOpration !== "deduct" &&	
							<Grid item xs={12}>
								<TextField
									label="ReferenceId" value={form.referenceid} onChange={changeValue.bind(this, "referenceid")} size="small" fullWidth />
							</Grid>
						}

						<Grid item xs={12}>
							<TextField
								label="Id Transacción Original" value={form.trx_id} onChange={changeValue.bind(this, "trx_id")} size="small" fullWidth />
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="Wallet Uuid" value={form.wallet_uuid} onChange={changeValue.bind(this, "wallet_uuid")} size="small" fullWidth />
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="Monto" type="number"  value={form.amount} onChange={changeValue.bind(this, "amount")} size="small" fullWidth inputProps={{min: 0, style: { width: "100%", textAlign: "inherit" }}}/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								label="Descripción" value={form.description} onChange={changeValue.bind(this, "description")} size="small" fullWidth />
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>    
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
					<Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Realizar Operación</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
  );
};

export default TutukaOperationManual;
